module.exports = __webpack_public_path__ + "static/media/Rotated tooth15.d8077b33.png";